import apiClient from "../api/client";
import {
  MarkMenuOutOfStockRequest,
  MenuItem,
  RestockMenuRequest,
  StoreStatus,
  HistoryItem,
  PagedResult,
  RecipeItem,
  MarkRecipeOutOfStockRequest,
  RestockRecipeRequest,
  OutOfStockItemDto,
} from "../types/outofstocktypes";

export const getMenus = (
  pageNumber: number,
  pageSize: number,
  searchTerm?: string,
  storeGroupGuid?: string
) =>
  apiClient.get<PagedResult<MenuItem>>(
    "/api/OutOfStock/grouped",
    {
      params: { pageNumber, pageSize, searchTerm, storeGroupGuid },
    }
  );

export const getMenuStores = (
  menuGuid: string,
  storeNumber?: string,
  status?: string
) =>
  apiClient.get<StoreStatus[]>(
    `/api/OutOfStock/${menuGuid}/stores`,
    {
      params: { storeNumber, status },
    }
  );

export const markMenuOutOfStock = (
  request: MarkMenuOutOfStockRequest
) =>
  apiClient.post("/api/OutOfStock/markmenuoutofstock", request);

export const restockMenu = (request: RestockMenuRequest) =>
  apiClient.post("/api/OutOfStock/restockmenu", request);

export const getOutOfStockHistory = (
  pageNumber: number,
  pageSize: number,
  menuGuid?: string,
  storeGuid?: string,
  itemName?: string,
  storeNumber?: string,
  status?: string,
  itemType?: string,
  startDate?: string,
  endDate?: string,
  userGuid?: string
) =>
  apiClient.get<PagedResult<HistoryItem>>(
    "/api/outofstock/history",
    {
      params: {
        pageNumber,
        pageSize,
        menuGuid,
        storeGuid,
        itemName,
        storeNumber,
        status,
        itemType,
        startDate,
        endDate,
        userGuid,
      },
    }
  );

export const getRecipes = (
  pageNumber: number,
  pageSize: number,
  searchTerm?: string,
  storeGroupGuid?: string
) =>
  apiClient.get<PagedResult<RecipeItem>>(
    "/api/OutOfStock/recipes/grouped",
    {
      params: { pageNumber, pageSize, searchTerm, storeGroupGuid },
    }
  );

export const getRecipeStores = (
  recipeGuid: string,
  storeNumber?: string,
  status?: string
) =>
  apiClient.get<StoreStatus[]>(
    `/api/OutOfStock/recipe/${recipeGuid}/stores`,
    {
      params: { storeNumber, status },
    }
  );

export const markRecipeOutOfStock = (
  request: MarkRecipeOutOfStockRequest
) =>
  apiClient.post(
    "/api/OutOfStock/markrecipeoutofstock",
    request
  );

export const restockRecipe = (
  request: RestockRecipeRequest
) =>
  apiClient.post("/api/OutOfStock/restockrecipe", request);

export const getMenusByRecipe = (recipeGuid: string) =>
  apiClient.get<MenuItem[]>(
    `/api/OutOfStock/recipes/${recipeGuid}/menus`
  );

export const getOutOfStockItems = (
  pageNumber: number,
  pageSize: number,
  search?: string,
  filter: string = "all",
  storeNumber?: string
) =>
  apiClient.get<PagedResult<OutOfStockItemDto>>(
    "/api/OutOfStock/items",
    {
      params: { pageNumber, pageSize, search, filter, storeNumber },
    }
  );